import type { ReactNode } from 'react';
import { ChevronDownIcon } from './icons';
import type { SortDirection, SortState } from '../lib/useTableSort';

export function SortableTh<K extends string>({
  label,
  sortKey,
  sort,
  onSort,
  align = 'left',
}: {
  label: ReactNode;
  sortKey: K;
  sort: SortState<K>;
  onSort: (key: K) => void;
  align?: 'left' | 'right';
}) {
  const active = sort?.key === sortKey;
  const direction: SortDirection = active ? sort.direction : 'asc';

  return (
    <th
      className={align === 'right' ? 'align-right' : undefined}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className={`sort-header${active ? ' is-active' : ''}${align === 'right' ? ' sort-header--right' : ''}`}
        onClick={() => onSort(sortKey)}
        title={`Ordenar por ${typeof label === 'string' ? label : 'columna'} (${active ? (direction === 'asc' ? 'descendente' : 'ascendente') : 'ascendente'})`}
      >
        <span>{label}</span>
        <ChevronDownIcon
          size={12}
          className={`sort-header__icon${active && direction === 'asc' ? ' sort-header__icon--asc' : ''}`}
        />
      </button>
    </th>
  );
}
